module.exports = __webpack_public_path__ + "static/deeeet-5239eea75772b637f2c1e7d314c8751c.jpg";